import React from "react";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import {
  BorderedButton,
  GradientBorderBox,
} from "../../../../../../Components";

export default function LeftSideGridItem({
  sx,
  text,
  btnText,
  image,
  seo_title = "not found",
  link = "/",
}) {
  const theme = useTheme();

  return (
    <Box
      component={Link}
      to={link}
      sx={{
        position: "relative",
        bgcolor: "transparent",
        backdropFilter: "blur(4px)",
        // overflow: "hidden",
        textDecoration: "none",
        color: theme.palette.common.white,
        cursor: "pointer",
        display: "block",
        "&:hover .hoveredImage": {
          filter: "blur(4px) brightness(0.6)",
          // transform: "scale(1.05)",
        },
        "&:hover .hoveredContent": {
          opacity: 1,
          transform: "translateY(0)",
        },
        ...sx,
      }}
    >
      {/* Background Image Container */}
      <Box
        className="hoveredImage"
        sx={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        <img
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          src={image}
          alt={seo_title}
        />
      </Box>

      {/* Foreground Overlay Content */}
      {(text || btnText) && (
        <Stack
          className="hoveredContent"
          sx={{
            position: "absolute",
            inset: 0,
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            gap: "1rem",
            p: "1.5rem",
            opacity: 0,
            transform: "translateY(15px)",
            transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
            zIndex: 10,
          }}
        >
          {text && (
            <Typography
              sx={{
                fontSize: "0.85rem",
                lineHeight: 1.7,
                textShadow: "0px 2px 4px rgba(0,0,0,0.6)",
              }}
            >
              {text}
            </Typography>
          )}
          {btnText && (
            <BorderedButton sx={{ fontSize: { xs: "0.75rem", md: "0.8rem" } }}>
              {btnText}
            </BorderedButton>
          )}
        </Stack>
      )}

      <GradientBorderBox
        bgGrad={`linear-gradient(
          120deg,
          ${theme.palette.background.white} -70%,
          ${theme.palette.background.default} 30%,
          ${theme.palette.background.gray} 200%
        )`}
        // inside
        overHidden
        zIndex={10}
        radius={{ xs: "1rem", xl: "1.5rem" }}
        bg={false}
      />
    </Box>
  );
}
